import actions from './actions';
import mutations from './mutations';
var state = {
  segments: [],
  segment_edit: {},
  audiencie_edit: {},
  coupons_edit: {},
  id_company: [],
  segment_new: {},
  coupons_new: {},
  audience_helper: {
    pagination: {
      current: 1,
      total: 0,
      limit: 10
    },
    filters: {},
    viewed: false
  },
  coupons_helper: {
    pagination: {
      current: 1,
      total: 0,
      limit: 10
    },
    filters: {},
    viewed: false
  },
  segment_helper: {
    pagination: {
      current: 1,
      total: 0,
      limit: 10
    },
    filters: {},
    viewed: false
  },
  request_data_active: false,
  share_action: false,
  gpt_images: false,
  audience_images: {},
  has_talonone_coupons: true,
  retail_purchase_prediction: false,
  has_edit_segment: false
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};